import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/embed/book/success")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/embed/book/success"!</div>;
}
